import service from '@/request/service';
import { getQueryStringByName } from '@/utils/helper';


// const MPayAppId = 'mp3pKGdIxS6gaqY9ag';

// import { getMpaySDKConfig } from '../../api/mtopApi';

const MpayConfigKey = `${getQueryStringByName('wapid')}MpayConfigKey`;

export const getMpayConfigKey = (key) => {
    const obj = JSON.parse(window.sessionStorage.getItem(MpayConfigKey) || JSON.stringify({}));
    // console.log('[dev]看看-get读缓存', obj);
    if (key) {
        return obj[key];
    } else {
        return obj;
    }
};

export const setMpayConfigKey = (params) => {
    const obj = JSON.parse(window.sessionStorage.getItem(MpayConfigKey) || JSON.stringify({}));
    // console.log('[dev]看看-set读缓存', obj);
    const res = {
        ...obj,
        ...params,
    };
    window.sessionStorage.setItem(MpayConfigKey, JSON.stringify(res));
};

export const goMpayAccreditPage = async (params) => {
    try {
        let staticAppid = 'mpsjM8s2NA0ow40Bi3';
        // 正式使用
        let apiBaseUrl = 'https://pay.macaupass.com/oauth2/authorize?';
        if (window.location.host === 'pre-site.icirena.ai') {
            staticAppid = 'mp3pKGdIxS6gaqY9ag';
            apiBaseUrl = 'https://uatpay.macaupass.com/oauth2/authorize?';
        }

        let mPaySDKId = staticAppid;
        try {
            const res = await service.getMpaySDKConfig();
            const { appId = staticAppid } = JSON.parse(res.data.bizValue) || {};
            mPaySDKId = appId;
        } catch (error) { }

        const { scope = 'userinfo', state = '' } = params || {};
        const config = {
            url: apiBaseUrl,
            appid: mPaySDKId,
            redirect_uri: encodeURIComponent(window.location.href),
            response_type: 'code',
            scope: scope,
            state: state,
        };

        let url = Object.keys(config).reduce((prev, cur, index) => {
            if (index === 0) {
                return prev + config[cur];
            } else {
                return `${prev}${cur}=${config[cur]}${index === Object.keys(config).length - 1 ? '' : '&'}`;
            }
        }, '');
        // console.log('[dev]看看-Mpay授权的url:', url);
        window.location.href = url; // 跳转到url
    } catch (error) {
        // console.log('[dev]看看-error:', error);
    }
};

export const initializeSdk = (params: any = {}) => {
    const { jsApiList = ['choosePayMent'] } = params || {};
    const res = new Promise((resolve) => {
        // ... some code
        // 正式使用
        let apiBaseUrl = 'https://pay.macaupass.com/data/static/js/mpayjsapi.min.js';
        if (window.location.host === 'pre-site.icirena.ai') {
            apiBaseUrl = 'https://uatpay.macaupass.com/data/static/js/mpayjsapi.min.js';
        }
        const cxz = async () => {
            const res = await service.getMpaySDKConfig();
            // console.log('[dev]看看-getMpaySDKConfigres:', res);
            if (res.result.bizCode === '0') {
                const { appId, timestamp, nonceStr, signature } = JSON.parse(res.result.bizValue) || {};
                const config = {
                    appId,
                    timestamp,
                    nonceStr,
                    signature,
                    jsApiList,
                };
                // @ts-ignore
                mp.config(config);
                // @ts-ignore
                mp.ready(() => {
                    // config信息驗證後執⾏ ready ⽅法，所有接⼝調⽤都必須在 config 接⼝獲得結果之後，config是⼀個客⼾端的異步操作，所以如果需要在⾴⾯加載時就調⽤相關接⼝，則須把相關接⼝放在 ready 函數中調⽤來確保正確執⾏。對於⽤⼾觸發時才調⽤的接⼝，則可以直接調⽤，不需要放在 ready 函數中。
                    // console.log('[dev]看看-ready ⽅法');
                    resolve(1);
                });
                // @ts-ignore
                mp.error(() => {
                    // config信息驗證失敗會執⾏ error 函數，如簽名過期導致驗證失敗，具體錯誤信息可以打開 config 的debug模式查看，也可以在返回的 res 參數中查看。
                    // console.log('[dev]看看-error 函數:', res);
                });
            }
        };

        if (document.getElementById('mpay-jssdk')) {
            cxz();
            return;
        }

        (function (d, s, id) {
            let js,
                fjs = d.getElementsByTagName(s)[0] as Element;
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = apiBaseUrl;
            fjs?.parentNode?.insertBefore(js, fjs);
        })(document, 'script', 'mpay-jssdk');
        let MpayScriptEl = document.querySelector('#mpay-jssdk') as Element;


        MpayScriptEl.addEventListener('load', cxz);
    });

    return res;
};

export const isMpay = () => {
    let ua = (navigator && navigator.userAgent) || '';
    let pattern = /.*mpay\d{0,3}.\d{0,3}.\d{0,3}/;
    return pattern.test(ua.toLowerCase());
};

export const getMpayLanguage = () => {
    if (!isMpay()) {
        return false;
    }
    let ua = (navigator && navigator.userAgent) || '';
    const res = ua.match(new RegExp('language/([^\&]+)', 'i'));
    if (res?.[1]) {
        //   const mpayLanguageMap={
        //     'zh':langguageType.TraditionalChinese,
        //     'en':langguageType.English,
        //   }
        //   return mpayLanguageMap[res[1]]
    }

    return false;
};
